import React from 'react';

import Error, { hasNamedError } from '../commons/component/error';
import Recaptcha from '../commons/component/captcha/recaptcha';
import InputNumber from '../commons/component/input-number';
import { InputPhone } from '../commons/component/input-mask';
import Checkbox from '../commons/component/checkbox';
import AempUserIcon from '../icons/aemp-user-icon';
import Button from '../commons/component/button';
import Input from '../commons/component/input';
import PasswordScore from './password-score';
import config from '../generated/config';
import EyeIcon from '../icons/eye-svg';
import { dispatchMetric } from '../metrics';
import { getEventPayload } from '../metrics/metrics.selector';

const FORM_FIELDS = [
  'cnpj',
  'corporateName',
  'fantasyName',
  'contactName',
  'phone',
  'buyerName',
  'buyerEmail',
  'buyerPhone',
  'buyerPassword',
  'buyerAlreadyRegistered'
];

export default class CadastroPjCompanyComponent extends React.Component {
  state = {
    isFormSubmitting: false,
    showPassword: false,
    passwordScore:
      window.zxcvbn && window.zxcvbn(this.props.formDataState.buyerPassword || '').score,
    buyer: {
      ...this.getSavedBuyerData()
    },
    errors: {},
    company: {
      ...this.props.formDataState
    }
  };

  componentDidMount() {
    const { buyerAlreadyRegistered } = this.props;
    if (buyerAlreadyRegistered) {
      this.setBuyerAlreadyRegistered();

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  render() {
    const errors = this.state.errors;
    const {
      hasCustomerQualifyer = false,
      goBackStep,
      currentStep,
      setCadastroPjDocumentState
    } = this.props;
    // const blockCorporateName = !!this.props.formDataState.corporateName;

    return (
      <div>
        <div className="cadastroHeader">
          <h2 className="cadastroForm-title">
            <AempUserIcon />
            <span>cadastro</span>
          </h2>
          <p className="cadastroSubtitle">
            que bom ter sua empresa por aqui, para iniciar seu cadastro, insira seu CNPJ para
            validarmos suas informações
          </p>
          {hasCustomerQualifyer && (
            <strong>
              verifique se as informações preenchidas automaticamente estão corretas. em caso
              positivo, clique em 'continuar'.
            </strong>
          )}
        </div>

        <form className="cadastroForm" onSubmit={this.handleSubmit}>
          <div className="inputGroup --marginBottomMd" id="cnpj">
            <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
              cnpj
            </label>
            <div className="addonWrapper">
              <InputNumber
                name="cnpj"
                id="cnpj-input"
                data-page="signup"
                data-form="signup"
                value={this.props.formDataState.cnpj}
                className={`inputGroup-input --withAddOn ${this.hasError('cnpj')}`}
                type="text"
                mask="__.___.___/____-__"
                placeholder="Ex: 12.345.678/1234-56"
                disabled
                required
              />
              <div className="inputText-addOn">
                <span
                  className="changeDocument"
                  onClick={() => goBackStep(currentStep, setCadastroPjDocumentState)}
                >
                  trocar
                </span>
              </div>
            </div>
            <Error errors={errors} name="cnpj" />
          </div>

          <div className="inputGroup" id="corporateName">
            <label className="inputGroup-label" htmlFor="corporateName-input">
              razão social
            </label>
            <Input
              name="corporateName"
              id="corporateName-input"
              onChange={this.changeField('corporateName')}
              value={this.state.company.corporateName || ''}
              data-page="signup"
              data-form="signup"
              className={`inputGroup-input --large ${this.hasError('corporateName')}`}
              type="text"
              // disabled={blockCorporateName}
            />
            <Error errors={errors} name="corporateName" />
          </div>

          <div className="inputGroup" id="fantasyName">
            <label className="inputGroup-label" htmlFor="fantasyName-input">
              nome fantasia
            </label>
            <Input
              name="fantasyName"
              id="fantasyName-input"
              onChange={this.changeField('fantasyName')}
              value={this.state.company.fantasyName || ''}
              data-page="signup"
              data-form="signup"
              className={`inputGroup-input --large ${this.hasError('fantasyName')}`}
              type="text"
            />
            <Error errors={errors} name="fantasyName" />
          </div>

          <div className="inputGroup" id="contactName">
            <label className="inputGroup-label" htmlFor="contactName-input">
              contato (nome e sobrenome)
            </label>
            <Input
              name="contactName"
              id="contactName-input"
              onChange={this.changeField('contactName')}
              value={this.state.company.contactName}
              data-page="signup"
              data-form="signup"
              className={`inputGroup-input --large ${this.hasError('contactName')}`}
              type="text"
            />
            <Error errors={errors} name="contactName" />
          </div>

          <div className="phone__wrapper">
            <div className="inputGroup" id="phone">
              <label className="inputGroup-label" htmlFor="phone-input">
                telefone do contato
              </label>
              <InputPhone
                data-form="signup"
                data-page="signup"
                onChange={this.changeField('phone')}
                value={this.state.company.phone || ''}
                name="phone"
                id="phone-input"
                className={`inputGroup-input ${this.hasError('phone')}`}
                type="text"
                placeholder="Ex: (99) 99999-9999"
              />
              <Error errors={errors} name="phone" />
            </div>
            <div className="inputGroup">
              <label className="inputGroup-label" htmlFor="phoneExtensionRegistry-input">
                ramal
              </label>
              <InputNumber
                name="phoneExtensionRegistry"
                id="phoneExtensionRegistry-input"
                onChange={this.changeField('phoneExtensionRegistry')}
                value={this.state.company.phoneExtensionRegistry || ''}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input phoneExtensionRegistry ${this.hasError(
                  'phoneExtensionRegistry'
                )}`}
                type="text"
                mask="_____"
              />
            </div>
          </div>

          <hr className="divisor md" />

          <div className="cadastroComprador">
            <div className="compradorHeader">
              <h3 className="compradorTitle">agora vamos criar seu login</h3>
              <p className="compradorSubtitle">
                informe seus dados de contato para criarmos o seu acesso. use sempre e-mail e número
                de celular válidos para, caso necessário, entrarmos em contato.
              </p>
              <p className="compradorSubtitle">
                para cadastrar um novo CNPJ dentro de uma conta já existente, insira{' '}
                <b>o mesmo email e senha usados no login desta conta.</b>
              </p>
            </div>

            <div className="inputGroup" id="buyerName">
              <label className="inputGroup-label" htmlFor="buyerName-input">
                nome e sobrenome
              </label>
              <Input
                name="buyerName"
                id="buyerName-input"
                onChange={this.changeBuyerField('buyerName')}
                value={this.state.buyer.buyerName}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input --large ${this.hasError('buyerName')}`}
                type="text"
              />
              <Error errors={errors} name="buyerName" />
            </div>

            <div className="inputGroup" id="buyerEmail">
              <label className="inputGroup-label" htmlFor="buyerEmail-input">
                e-mail
              </label>
              <Input
                placeholder="Ex. joaodasilva@gmail.com"
                className={`inputGroup-input --large ${this.hasError('buyerEmail')} ${this.hasError(
                  'buyerAlreadyRegistered'
                )}`}
                data-page="signup"
                data-form="signup"
                name="buyerEmail"
                onChange={this.changeEmail}
                value={this.state.buyer.buyerEmail}
                id="buyerEmail-input"
                type="buyerEmail"
              />
              <Error errors={errors} name="buyerEmail" />
            </div>

            {/* <div className="phone__wrapper">
              <div className="inputGroup" id="buyerPhone">
                <label className="inputGroup-label" htmlFor="buyerPhone-input">
                  Telefone
                </label>
                <InputMask
                  data-form="signup"
                  data-page="signup"
                  onChange={this.changeField('buyerPhone')}
                  value={this.state.buyer.buyerPhone}
                  name="buyerPhone"
                  id="buyerPhone-input"
                  className={`inputGroup-input ${this.hasError('buyerPhone')}`}
                  type="text"
                  mask="(__) _____-____"
                  placeholder="Ex: (99) 99999-9999"
                />
                <Error errors={errors} name="buyerPhone" />
              </div>
              <div className="inputGroup">
                <label className="inputGroup-label" htmlFor="buyerPhoneExtensionRegistry-input">
                  ramal
                </label>
                <InputNumber
                  name="buyerPhoneExtensionRegistry"
                  id="buyerPhoneExtensionRegistry-input"
                  onChange={this.changeField('buyerPhoneExtensionRegistry')}
                  value={this.state.buyer.buyerPhoneExtensionRegistry}
                  data-page="signup"
                  data-form="signup"
                  className={`inputGroup-input phoneExtensionRegistry ${this.hasError(
                    'buyerPhoneExtensionRegistry'
                  )}`}
                  type="text"
                  mask="_____"
                />
              </div>
            </div> */}

            <div className="inputGroup" id="buyerPhone">
              <label className="inputGroup-label" htmlFor="buyerPhone-input">
                celular
              </label>
              <InputPhone
                data-form="signup"
                data-page="signup"
                onChange={this.changeBuyerField('buyerPhone')}
                value={this.state.buyer.buyerPhone}
                name="buyerPhone"
                id="buyerPhone-input"
                className={`inputGroup-input ${this.hasError('buyerPhone')}`}
                type="text"
                placeholder="Ex: (99) 99999-9999"
              />
              <Error errors={errors} name="buyerPhone" />
            </div>

            <div className="inputGroup" id="buyerPassword">
              <label className="inputGroup-label" htmlFor="buyerPassword-input">
                senha
                <span className="passwordHelp">
                  sua senha precisa conter pelo menos 1 número, 1 caracter especial e uma letra
                  maiúscula
                </span>
              </label>
              <div className="passwordWrapper">
                <Input
                  name="buyerPassword"
                  id="buyerPassword-input"
                  data-form="signup"
                  data-page="signup"
                  type={this.state.showPassword ? 'text' : 'password'}
                  onChange={this.changePassword}
                  value={this.state.buyer.buyerPassword}
                  className={`inputGroup-input --withAddOn ${this.hasError(
                    'buyerPassword'
                  )} ${this.hasError('buyerAlreadyRegistered')}`}
                  autoComplete={false}
                  required
                />
                <div role="button" className="inputGroup-addOn" onClick={this.toggleShowPassword}>
                  <EyeIcon on={!this.state.showPassword} />
                </div>
              </div>
              <Error errors={errors} name="buyerPassword" />
              <Error errors={errors} name="buyerAlreadyRegistered" />
              {!errors.buyerAlreadyRegistered && (
                <PasswordScore className="inputGroup-score" score={this.state.passwordScore} />
              )}
            </div>

            <div className="inputGroup --checkbox">
              <Checkbox
                className="inputGroup-checkbox"
                name="offersEmail"
                onChange={this.changeBuyerField('offersEmail')}
                checked={this.state.buyer.offersEmail}
                data-form="signup"
                data-page="signup"
              >
                desejo receber ofertas e comunicações da Americanas Empresas por e-mail
              </Checkbox>
            </div>
          </div>

          {/* <div className="phone__wrapper">
            <div className="inputGroup" id="cellphone">
              <label className="inputGroup-label" htmlFor="cellphone-input">
                celular
              </label>
              <InputMask
                data-form="signup"
                data-page="signup"
                onChange={this.changeField('cellphone')}
                value={this.state.company.cellphone || ''}
                name="cellphone"
                id="cellphone-input"
                className={`inputGroup-input ${this.hasError('cellphone')}`}
                type="text"
                mask="(__) _____-____"
                placeholder="Ex: (99) 99999-9999"
              />
              <Error errors={errors} name="cellphone" />
            </div>
          </div> */}
          {config.enableCaptchaOnPJRegister && <Recaptcha ref={ref => (this.captcha = ref)} />}

          <div className="cadastro-buttons">
            <Button
              primary
              disabled={this.state.isFormSubmitting}
              loading={this.state.isFormSubmitting}
              className="cadastroForm-submit"
            >
              continuar
            </Button>
            <button
              className="btn button-ghost"
              disabled={this.state.isFormSubmitting}
              onClick={() => goBackStep(currentStep, setCadastroPjDocumentState)}
            >
              voltar
            </button>
          </div>
        </form>
      </div>
    );
  }

  handleSubmit = async evt => {
    evt.preventDefault();
    this.setState({ isFormSubmitting: true });

    const { submitHandler, formDataState, setCadastroPjDocumentState, currentStep } = this.props;

    const eventType = 'event_signup';

    const metricPayload = {
      event: eventType,
      eventCategory: 'tela-cadastro-etapa-2',
      eventAction: 'continuar'
    };

    const metricEventPayload = getEventPayload({ ...metricPayload });

    try {
      const formData = { ...this.state.company, ...this.state.buyer };
      await submitHandler(
        formData,
        FORM_FIELDS,
        this.captcha,
        formDataState,
        setCadastroPjDocumentState,
        currentStep
      );
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'sucesso',
          ...metricEventPayload
        }
      });
    } catch (errors) {
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'erro:campo-invalido',
          ...metricEventPayload
        }
      });
      this.setState({ errors, isFormSubmitting: false });
    }
  };

  getSavedBuyerData() {
    const { formDataState } = this.props;
    return {
      buyerPassword: formDataState.buyerPassword || '',
      buyerEmail: formDataState.buyerEmail || '',
      buyerName: formDataState.buyerName || '',
      buyerPhone: formDataState.buyerPhone || '',
      offersEmail: formDataState.offersEmail === 'true'
    };
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  checkPasswordStrength(password) {
    if (password) {
      this.setState({
        passwordScore: (window.zxcvbn && window.zxcvbn(password).score) || 0
      });
    } else {
      this.setState({ passwordScore: 0 });
    }
  }

  setBuyerAlreadyRegistered() {
    this.setState({
      errors: {
        ...this.state.errors,
        buyerAlreadyRegistered: 'revise seu e-mail e senha'
      }
    });
  }

  cleanBuyerAlreadyRegisteredError() {
    const { clearBuyerAlreadyRegistered, setCadastroPjDocumentState } = this.props;
    clearBuyerAlreadyRegistered(setCadastroPjDocumentState);
    return this.setState({
      errors: {
        ...this.state.errors,
        buyerAlreadyRegistered: ''
      }
    });
  }

  changeEmail = e => {
    const buyerEmail = e.target.value;
    this.setState({
      buyer: {
        ...this.state.buyer,
        buyerEmail
      }
    });
    this.cleanBuyerAlreadyRegisteredError();
  };

  changePassword = e => {
    const buyerPassword = e.target.value;
    this.setState({
      buyer: {
        ...this.state.buyer,
        buyerPassword
      }
    });
    this.cleanBuyerAlreadyRegisteredError();
    this.checkPasswordStrength(buyerPassword);
  };

  changeBuyerField(name) {
    return e =>
      this.setState({
        buyer: {
          ...this.state.buyer,
          [name]: e.target.value
        }
      });
  }

  changeField(name) {
    return e =>
      this.setState({
        company: {
          ...this.state.company,
          [name]: e.target.value
        }
      });
  }
}
